var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    color: "#000000",
    transform: "rotate(180)matrix(-1, 0, 0, 1, 0, 0)",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", {
    id: "directionRightIconTitle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 7H10.8333C10.8333 7 5 7 5 12.8333C5 18.6667 5 21 5 21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11L19 7L15 3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRight);
export default __webpack_public_path__ + "static/media/Top-Right.99456db01af1ca2b9c50f4add2dd3c5a.svg";
export { ForwardRef as ReactComponent };